module.exports = __webpack_public_path__ + "static/media/left.4202f385.svg";